import { createSlice } from "@reduxjs/toolkit";

const appSlice = createSlice({
  name: "app",
  initialState: {
    territory: null,
    channel: "retail",
    isOrdering: false,
    productView: "grid",
    sidebarOpen: true,
    branchSelectorVisible: true,
  },
  reducers: {
    setTerritory: (state, action) => {
      state.territory = action.payload;
    },
    setChannel: (state, action) => {
      state.channel = action.payload;
    },
    setIsOrdering: (state, action) => {
      state.isOrdering = action.payload;
    },
    setProductView: (state, action) => {
      state.productView = action.payload;
    },
    setSidebarOpen: (state, action) => {
      state.sidebarOpen = action.payload;
    },
    setBranchSelectorVisible: (state, action) => {
      state.branchSelectorVisible = action.payload;
    },
  },
});

export const {
  setTerritory,
  setChannel,
  setIsOrdering,
  setProductView,
  setSidebarOpen,
  setBranchSelectorVisible,
} = appSlice.actions;

export default appSlice.reducer;
